import { render } from "./Invalid.vue?vue&type=template&id=3b7061ea&ts=true"
import script from "./Invalid.vue?vue&type=script&lang=ts"
export * from "./Invalid.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__